import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-slider" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "card-slider-wrapper" }

import Equalize from '@/utils/Equalize';
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUpdated,
  ref,
  useSlots,
  h,
  VNode,
} from 'vue';
import {
  Carousel,
  Slide,
} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronsRight, faChevronsLeft } from '@fortawesome/pro-solid-svg-icons';
import ResponsiveSize from '@/classes/ResponsiveSize';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardSlider',
  setup(__props) {

library.add(faChevronsRight);
library.add(faChevronsLeft);

const carouselEl = ref<InstanceType<typeof Carousel>>();

const slots = useSlots();
const slotDefault = computed(() => (slots.default ? slots.default() : null));
const slideItems = ref<VNode[]>([]);
const numItems = computed<number>(() => slideItems.value.length);
const clickToNext = ref(false);
const clickToPrev = ref(true);
const currentIndex = ref<number>(0);
const itemsToShow = ref<number>(1);

const updateCurrentIndex = async (index: number) => {
  await new Promise<void>((resolve) => {
    setTimeout(() => {
      currentIndex.value = index;
      resolve();
    }, 500);
  });
};

const toPrev = () => {
  const newIndex = currentIndex.value - 1;
  updateCurrentIndex(newIndex);
  carouselEl.value.prev();

  if (newIndex > 0) {
    clickToPrev.value = true;
  } else {
    clickToNext.value = false;
  }
};

const toNext = () => {
  if (!carouselEl.value) return;

  const newIndex = currentIndex.value + 1;
  updateCurrentIndex(newIndex);
  carouselEl.value.next();

  if (newIndex < numItems.value - itemsToShow.value) {
    clickToNext.value = true;
  } else {
    clickToPrev.value = false;
  }
};

const isMobileBreakpoint = ResponsiveSize.isMobileBreakpoint();

const showNavigation = computed(() => (
  isMobileBreakpoint
    ? numItems.value > 1
    : numItems.value > 4
));

const setItemsToShow = (event: CustomEvent) => {
  const breakpoints = event.detail?.currentBreakpoints || [] as string[];
  const lastBreakpoint = [...(breakpoints || [])].reverse()[0] || 'xs';
  switch (lastBreakpoint) {
    case 'sm':
      itemsToShow.value = 2;
      break;
    case 'md':
      itemsToShow.value = 2;
      break;
    case 'lg':
      itemsToShow.value = 3;
      break;
    case 'xl':
      itemsToShow.value = 3;
      break;
    case 'xxl':
    case 'xxxl':
      itemsToShow.value = 4;
      break;
    default:
      itemsToShow.value = 0.78;
  }
};

const containerEl = ref<HTMLElement>();
const triggerAutoEqualize = () => {
  if (!containerEl.value) return;

  Equalize.run(containerEl.value);
};

const preventMapSlotItems = ref<boolean>(false);
const mapDefaultSlotItems = () => {
  if (preventMapSlotItems.value) {
    preventMapSlotItems.value = false;
    return;
  }
  let items: any[] = [];
  if (typeof slotDefault.value?.[0]?.type === 'symbol') {
    items = (slotDefault.value?.[0]?.children || []) as any[];
  } else {
    items = slotDefault.value || [];
  }

  preventMapSlotItems.value = true;
  nextTick(() => {
    slideItems.value = [...items].map((item: any) => h(Slide, {
      class: 'card-slider__item',
    }, () => [h('div', {
      class: 'card-slider__item-wrapper',
    }, [item])]));

    ResponsiveSize.onBreakpointChanged(setItemsToShow, true);

    setTimeout(triggerAutoEqualize, 50);
  });
};

onMounted(mapDefaultSlotItems);

onUpdated(triggerAutoEqualize);
onUpdated(() => {
  mapDefaultSlotItems();
});

onBeforeUnmount(() => {
  ResponsiveSize.removeOnBreakpointChanged(setItemsToShow);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerEl",
    ref: containerEl,
    class: "card-slider-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (slideItems.value.length)
            ? (_openBlock(), _createBlock(_unref(Carousel), {
                key: 0,
                ref_key: "carouselEl",
                ref: carouselEl,
                class: _normalizeClass(["io-eq", { 'mobil': _unref(isMobileBreakpoint) }]),
                "items-to-show": itemsToShow.value,
                transition: 500,
                "mouse-drag": false,
                "touch-drag": _unref(isMobileBreakpoint),
                "wrap-around": false,
                "snap-align": _unref(isMobileBreakpoint) ? 'center' : 'start',
                onSlideStart: triggerAutoEqualize
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slideItems.value, (slideItem, inx) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(slideItem), {
                      key: `slide-item-${inx}-${slideItem}`
                    }))
                  }), 128))
                ]),
                _: 1
              }, 8, ["class", "items-to-show", "touch-drag", "snap-align"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (showNavigation.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (clickToNext.value || _unref(isMobileBreakpoint))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "card-slider__prev",
                onClick: toPrev
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevrons-left" })
              ]))
            : _createCommentVNode("", true),
          (clickToPrev.value || _unref(isMobileBreakpoint))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "card-slider__next",
                onClick: toNext
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevrons-right" })
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 512))
}
}

})